import { getZoneFromSite, siteNames } from '@seek/melways-sites';
import { Brand, Product } from '../../types.js';
export default {
    audience: 'https://seek/api/candidate',
    authDomain: 'login.seek.com',
    clientDomain: 'sg.jobstreet.com',
    clientId: 'Uwik845Sw4GL6U80RWmGnyfost3B9p94',
    environment: 'prod',
    redirectPath: '/oauth/callback/',
    realm: 'Username-Password-Authentication',
    brand: Brand.JOBSTREET,
    contactUs: {
        en: 'https://sg.jobstreet.com/contact-us/',
    },
    siteName: siteNames.candidate.jobstreet.sg,
    zone: getZoneFromSite(siteNames.candidate.jobstreet.sg),
    product: Product.SEEK,
};
//# sourceMappingURL=sg_jobstreet_com.js.map